export default __webpack_public_path__ + "static/media/someta.b8805b4f.png";